import { type Clip } from '@air/api/types';

export const getFilename = ({ title, importedName, ext }: Pick<Clip, 'title' | 'importedName' | 'ext'>) =>
  (title || importedName) + (ext ? `.${ext}` : '');
